import { useTheme } from '@emotion/react'
import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router'
import { useLocation } from "react-router-dom"
import GlobalLoader from "../components/backdrop"
import Alert from '../components/dialog/Alert'
import FooterComponent from '../components/footer'
import Header from '../components/header'
import Sidebar from '../components/sidebar'
import Toaster from '../components/toaster/toaster'
import AccessDenied from '../pages/accessDenied'
import { UrlRestrictionsArray } from '../utils/common'
import { getParamMasterList } from './action'
import useDeviceType from '../hooks/useDeviceType'
import SidebarMobile from '../components/sidebarMobile'
const Layout = () => {
  const theme = useTheme()
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const toolbarHeight = theme.spacing(0);
  const states = useSelector(state => state.app)
  const location = useLocation();

  useEffect(() => {
    dispatch(getParamMasterList());
  }, []);




  const url = location?.pathname?.split("/")?.filter((v) => v !== '')[0];
  const permessions = UrlRestrictionsArray.find((v) => v.urlKey === url);
  if (states.permissions?.[permessions?.pKey]?.view == 0) {
    return <AccessDenied />
  }

  const discoverBackgroundPaths = ['/discover-influencers', '/discover-influencers/listing'];
  const discoverInfluListingPaths = [
    '/discover-influencers/listing',
    '/wallet',
    '/company-brands',
    '/my-campaigns',
    '/subscription/history',
    '/subscription/active'
  ];

  return (
    <>
      <Header />
      <Toaster />
      <GlobalLoader />
      {deviceType === 'desktop' ? <Sidebar /> : <SidebarMobile/>}
      <Box
        className={`bodyArea 
    ${discoverBackgroundPaths.includes(location.pathname) ? "discover-background" : "bg-f0f0f0"} 
    ${discoverInfluListingPaths.some(path => location.pathname.startsWith(path) || location.pathname === path)
            ? "discover-influ-listing"
            : ""}`
        }
        ml={states.sidebarWidth}
        px={3}
        py={location.pathname === '/discover-influencers/listing' ? 0 : 2}
        position="relative"
        minHeight={`calc(100vh - ${toolbarHeight})`}
        sx={{
          paddingTop: location.pathname === '/discover-influencers/listing' ? '64px' : '88px',
          transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`
        }}
      >
        <div className='innerBody'>
          <div className='containerFluid' style={{padding:`${(location.pathname==='/discover-influencers/listing'|| location.pathname==='/wallet' || location.pathname === '/my-campaigns') ? "0px" : "0px 0px 30px 0px"}`}}>
            <Outlet />
          </div>
        </div>
        <FooterComponent />
      </Box>
      <Alert />
    </>
  )
}

export default Layout